/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type InvoiceSignatureType = 1 | 2 | 3 | 4;

export const InvoiceSignatureType = {
    NUMBER_1: 1 as InvoiceSignatureType,
    NUMBER_2: 2 as InvoiceSignatureType,
    NUMBER_3: 3 as InvoiceSignatureType,
    NUMBER_4: 4 as InvoiceSignatureType
}